module.exports = __webpack_public_path__ + "zarustajici-nehty_3_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/zarustajici-nehty_3_after_tn.jpg
// module id = 1509
// module chunks = 0